import StorageStatistics from './StorageStatistics';
export default StorageStatistics;
